module.exports = __webpack_public_path__ + "static/media/carlysh_carlysh-R2-018-7A.d800b91c.jpg";